export enum Route {
  HOME = '/',
  RESULT = '/result',
  SPEED_TEST_DETAIL = '/learn_more',
  ADDITIONAL_DETAILS = '/additional_details',
}
